module.exports = __webpack_public_path__ + "img/couches.e612cad2.png";